import React from 'react';
import { FloatContainer as Container } from './FloatStyles';

function FloatContainerComponent() {
  return <Container id="float-container" />;
}

export const FloatContainer = FloatContainerComponent;
